import { CartItem } from '@eshop/types/cart.types.ts';

export interface PotentialPaymentPromotionMessage {
  key: string;
  text: string;
  paymentMethodIds: number[];
}

const normalizeIds = (values?: Array<number | string> | null): number[] => (
  (values ?? [])
    .map((value) => Number(value))
    .filter((value) => Number.isFinite(value) && value > 0)
);

const normalizeMessage = (value: string): string => value.trim().replace(/\s+/g, ' ').toLowerCase();

export const getPotentialPaymentPromotionMessages = (
  items: CartItem[],
  selectedPaymentMethodId?: number,
): PotentialPaymentPromotionMessage[] => {
  const messages: PotentialPaymentPromotionMessage[] = [];
  const seen = new Set<string>();

  for (const item of items) {
    const itemHasExplicitPaymentPromotions = (item.potential_payment_promotions?.length ?? 0) > 0;
    for (const promotion of item.potential_payment_promotions ?? []) {
      const paymentMethodIds = normalizeIds(promotion.payment_method_ids);
      if (selectedPaymentMethodId && paymentMethodIds.includes(selectedPaymentMethodId)) {
        continue;
      }
      const messageKey = normalizeMessage(promotion.summary);
      const key = `${messageKey}:${paymentMethodIds.join(',')}`;
      if (seen.has(key)) {
        continue;
      }
      seen.add(key);
      messages.push({
        key,
        text: promotion.summary,
        paymentMethodIds,
      });
    }

    if (itemHasExplicitPaymentPromotions) {
      continue;
    }

    for (const promotion of item.item?.promotions ?? []) {
      const summary = promotion.catalog_condition_summary?.trim();
      if (!summary || !promotion.requires_cart_state || !summary.toLowerCase().includes('abonando con')) {
        continue;
      }
      const key = normalizeMessage(summary);
      if (seen.has(key)) {
        continue;
      }
      seen.add(key);
      messages.push({
        key,
        text: summary,
        paymentMethodIds: [],
      });
    }
  }

  return messages;
};
